module.exports = __webpack_public_path__ + "img/icon-filter.103c4845.svg";